// a list of ids that should be excluded from the form
export const formValidationErrorExceptionMessage = 'Form validation error';

export function scrollToFirstSuggestion() {
  const targetElement = document.querySelector('.suggestion-validation-button');
  if (targetElement) {
    targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
